import { useTranslation } from 'react-i18next'

import { RadioGroupModal } from '../../Radio'

import {
  LABEL_ENTITY_ASSIGNMENTS_FIELD,
  LABEL_ENTITY_ASSIGNMENTS_INITIAL,
} from './LabelEntityAssignmentsConfirmationModal.constants'
import {
  getLabelEntityAssignmentsOptions,
  isLabelEntityAssignmentsChoiceKeep,
} from './LabelEntityAssignmentsConfirmationModal.utils'

import * as styles from './LabelEntityAssignmentsConfirmationModal.module.css'

function LabelEntityAssignmentsConfirmationModal({
  assignmentCount,
  onCancel,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  function getOptions() {
    return getLabelEntityAssignmentsOptions(t)
  }

  function handleSubmit(values) {
    const choice = values[LABEL_ENTITY_ASSIGNMENTS_FIELD]

    onSubmit({
      keep_assignments: isLabelEntityAssignmentsChoiceKeep(choice),
    })
  }

  return (
    <RadioGroupModal
      formFieldsProps={{
        actionsProps: {
          submitProps: { title: 'Modal.ContinueBtnKey' },
        },
        getOptions,
        name: LABEL_ENTITY_ASSIGNMENTS_FIELD,
        radioComponentProps: {
          containerProps: {
            className: styles.radioContainer,
          },
          labelProps: {
            className: styles.radioLabel,
          },
        },
        title: t('Label.EditEntityAssignmentsDescriptionKey', {
          count: assignmentCount,
        }),
      }}
      initialValues={LABEL_ENTITY_ASSIGNMENTS_INITIAL}
      title={t('Label.EditEntityAssignmentsTitleKey')}
      onCancel={onCancel}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default LabelEntityAssignmentsConfirmationModal
